// useFetchListaDeCajas.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchCajas = (idBranch) => {
  const [cajas, setCajas] = useState([]);
  const [nombreSucursal, setNombreSucursal] = useState('');
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false); 
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1); // Estado para el total de páginas
  const [msj,setmsj] = useState("🛈 Para ver los registros seleccione una fecha de inicio y una fecha fin con un rango no mayor a 31 días.")
  
  const fetchCajas = async (fechaInicio = '', fechaFin = '', page = 1, apellido = '') => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Token no disponible.');
      setLoading(false);
      return;
    }
    
    const API_URL = process.env.REACT_APP_URL;

    setIsFetching(true); 
    setLoading(true) 
    setError(null); // Limpiar error antes de la nueva consulta
    try {
      const body = {
        idBranches: idBranch,
   
      };
      // Solo incluir fechas si están defini das
      if (fechaInicio) body.inicio = fechaInicio;
      if (fechaFin) body.fin = fechaFin;
      const response = await axios.post(
        `${API_URL}/public/v2/Audit/ListBranches`,
        body,
        {
          headers: {
            'SERVICIOS-URBANOS-TOKEN': token,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
          },
        }
      );

      if (response.data.msg && Array.isArray(response.data.msg)) {
        const sucursal = response.data.msg.find(branch => branch.sucursal.id === idBranch);
        setNombreSucursal(sucursal ? sucursal.sucursal.name : 'Sucursal desconocida');
        setCajas(response.data.msg || []);
      } else {
        setError('No se encontraron datos.');
      }
    } catch (err) {
      console.error('Error de la API:', err.response?.data || err.message);
      setError( err.response.data.msg || 'Cajas no disponibles.');
    } finally {
      setIsFetching(false);
      setLoading(false);
      setmsj(null)
    }
  };



  return { cajas, nombreSucursal, loading, isFetching, error, fetchCajas, totalPages,msj };
};

export default useFetchCajas;
